// extracted by mini-css-extract-plugin
export default {"guide-block":"personal-details-module__guide-block--LCf","guideBlock":"personal-details-module__guide-block--LCf"};